/**
 * Enhance article <pre> blocks with a Copy button.
 * Runs on article pages only when this script is loaded.
 */
(function () {
  function getCodeText(pre) {
    var code = pre.querySelector('code');
    return (code || pre).textContent.replace(/\u00a0/g, ' ').replace(/\r\n/g, '\n');
  }

  function enhance(pre) {
    if (pre.closest('.code-block')) return;

    var wrap = document.createElement('div');
    wrap.className = 'code-block';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'code-block__copy';
    btn.setAttribute('aria-label', 'Copy source code');
    btn.textContent = 'Copy';

    var idleLabel = 'Copy';
    var doneLabel = 'Copied';

    btn.addEventListener('click', function () {
      var text = getCodeText(pre);
      var done = function () {
        btn.textContent = doneLabel;
        btn.classList.add('code-block__copy--done');
        window.setTimeout(function () {
          btn.textContent = idleLabel;
          btn.classList.remove('code-block__copy--done');
        }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(function () {
          fallbackCopy(text, done);
        });
      } else {
        fallbackCopy(text, done);
      }
    });

    pre.parentNode.insertBefore(wrap, pre);
    wrap.appendChild(btn);
    wrap.appendChild(pre);
  }

  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      done();
    } catch (e) {
      /* ignore */
    }
    document.body.removeChild(ta);
  }

  function init() {
    var root = document.querySelector('.main-article__body, .wp-content');
    if (!root) return;
    root.querySelectorAll('pre').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
